import DateUtils from "../../../utils/dateUtils";
import { RefObject } from "react";

export class ToolTip {
    selector: d3.Selection<HTMLDivElement, unknown, HTMLElement, any>;
    mouseXOffSet: number;
    mouseYOffSet: number;
    opacity: number;
    x: number;
    y: number;

    constructor(
        selector: any,
        className = null,
        opacity = 0.9,
        mouseXOffSet = 10,
        mouseYOffSet = -25
    ) {
        this.selector = selector;
        this.mouseXOffSet = mouseXOffSet;
        this.mouseYOffSet = mouseYOffSet;
        this.opacity = opacity;
        this.x = 0;
        this.y = 0;
        this.changeClass(className);
        this.clean();
        this.hide();
    }

    changeClass(className: string | null) {
        if (className) {
            this.selector.attr("class", className);
        } else {
            this.setDefaultStyle();
        }
    }

    style(property: string, value: string) {
        return this.selector.style(property, value);
    }

    setDefaultStyle() {
        this.style("position", "absolute");
        this.style("padding", "10px");
        this.style("background", "white");
        this.style("border", "1px");
        return this.style("border-radius", "8px");
    }

    html(html: string) {
        this.clean();

        return this.selector.html(html);
    }

    clean(msg = "Error") {
        return this.selector.html(msg);
    }

    showLast() {
        return this.show(this.x, this.y);
    }

    show(x: number, y: number) {
        this.x = x;
        this.y = y;
        this.selector.style("opacity", this.opacity);
        this.selector.style("left", `${x + this.mouseXOffSet}px`);
        this.selector.style("display", "block");

        return this.selector.style("top", `${y + this.mouseYOffSet}px`);
    }

    hide() {
        return this.selector.style("display", "none");
    }
}

export class StatToolTip extends ToolTip {
    mapRef: RefObject<HTMLDivElement>;

    constructor(
        selector: any,
        mapRef: RefObject<HTMLDivElement>,
        className = null,
        opacity = 0.9,
        mouseXOffSet = -50,
        mouseYOffSet = -25
    ) {
        super(selector, className, opacity, mouseXOffSet, mouseYOffSet);
        this.mapRef = mapRef;
    }
    private getMinutedisplay(minutes: number) {
        return DateUtils.displayMinutes(minutes);
    }

    show(x: number, y: number) {
        const clientWidth = window.innerWidth;
        const clientHeight = window.innerHeight;

        const elementRect = this.mapRef.current?.getBoundingClientRect()
        const mouseXRelative = elementRect ? x - elementRect?.left : 0;
        const mouseYRelative = elementRect ? y - elementRect?.top : 0;
        const elementWidth = elementRect ? elementRect.width : 1;
        const elementHeight = elementRect ? elementRect.height : 1;

        this.x = x;
        this.y = y;
        this.selector.style("opacity", this.opacity);
        if(mouseXRelative <= elementWidth/2) {
            this.selector.style("right", `auto`);
            this.selector.style("left", `${x + this.mouseXOffSet}px`);
        }
        else {
            this.selector.style("left", `auto`);
            this.selector.style("right", `${clientWidth - x}px`);
        }
        this.selector.style("display", "block");

        if(mouseYRelative <= elementHeight/2) {
            this.selector.style("bottom", `auto`)
            return this.selector.style("top", `${y + this.mouseYOffSet}px`)
        }
        else {
            this.selector.style("top", `auto`)
            return this.selector.style("bottom", `${clientHeight - y + this.mouseYOffSet}px`)
        }

    }

    populate(roomName: string, minutes: number) {
        this.clean();
        let html = "<div style='text-align:center'>";
        html += `<b>${roomName}</b></br>`;
        html += `${this.getMinutedisplay(minutes)}</br>`;
        html += "</div>";

        this.html(html);
    }
}
